export default __webpack_public_path__ + "static/service-2-1aa528397865671961c8fd61cadbb8b8.jpg";